export default __webpack_public_path__ + "static/media/admission04.bc99ee39.jpeg";